export default __webpack_public_path__ + "static/media/aiObjectActive.30f220cc.svg";